import { Box, Grid, TablePagination, TextField } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { TeamTile } from "../../../../components/analysis/tiles";
import QuickSearch from "../../../../components/analysis/quickSearch";
import { useGlobal } from "../../../../context/GlobalProvider";

export default function AnalysisTeamSearch() {
  const { eventList, teamList } = useGlobal();

  const [teamsShown, setTeamsShown] = useState(12);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(
      teamList.filter(
        (team) =>
          team.team_number.toString().includes(search) ||
          team.team_name
            .toLowerCase()
            .replace(/\./g, "")
            .trim()
            .includes(search.toLowerCase().replace(/\./g, "").trim())
      ).length
    );
  }, [teamList]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(Math.floor(page * (teamsShown / parseInt(event.target.value, 10))));
    setTeamsShown(parseInt(event.target.value, 10));
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setPage(0);
    setCount(
      teamList.filter(
        (team) =>
          team.team_number.toString().includes(search) ||
          team.team_name
            .toLowerCase()
            .replace(/\./g, "")
            .trim()
            .includes(search.toLowerCase().replace(/\./g, "").trim())
      ).length
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={2}
        sx={{
          display: { xs: "flex", sm: "none" },
          justifyContent: "left",
          alignContent: "top",
        }}
      >
        <QuickSearch events={eventList} teams={teamList} />
      </Grid>
      <Grid item xs={10} sm={12} lg={6} sx={{ mb: 2 }}>
        <Box
          sx={{ display: "flex", justifyContent: { xs: "center", lg: "left" } }}
        >
          <TextField
            name="searchTeam"
            label="Search"
            variant="filled"
            sx={{ width: "80%", borderRadius: 20 }}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Box>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
          }}
        >
          <TablePagination
            count={count}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={teamsShown}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[12, 24, 48]}
            sx={{ bgcolor: "#444", borderRadius: 5, scrollbarWidth: "none" }}
            labelRowsPerPage="Teams Per Page"
          />
        </Box>
      </Grid>
      {teamList
        .filter(
          (team) =>
            team.team_number.toString().includes(search) ||
            team.team_name
              .toLowerCase()
              .replace(/\./g, "")
              .trim()
              .includes(search.toLowerCase().replace(/\./g, "").trim())
        )
        .slice(page * teamsShown, page * teamsShown + teamsShown)
        .map((team) => (
          <TeamTile key={team.team_number} team={team} />
        ))}
    </Grid>
  );
}
